import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";
import { IDetalhesInclusaoContasAPagar } from "./ObterDetalhesDaInclusaoDeContasAPagar";

export const ObterDetalhesDaInclusaoDeContasAPagarConsulta = async (
  documento: string,
  codLoja: number
): Promise<IDetalhesInclusaoContasAPagar> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IDetalhesInclusaoContasAPagar>(
      `/obter-detalhes-da-previsao-de-pagamento-CONSULTA`,
      { params: { documento, codLoja }, headers: { token } }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter os detalhes da inclusão de contas a pagar"
    );
  }
};